import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader'
import MainFooter from '../../../components/MainFooter'
import { motion } from "framer-motion";

import './NewsDetails.css'
import './MNewsDetails.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';

import { URL_STRAPI, API_TOKEN_STRAPI, boxvar1, boxvar3, MarkdownViewer } from '../../../core.js'


export default function NewsDetails() {

    let { newsid } = useParams()

    const [newsData, setNewsData] = useState(null);

    const fetchAllNews = async () => {
        const res = await axios.get(`${URL_STRAPI}/api/news-articles`, {
            params: {
                'filters[newsid][$eq]': newsid,
                'filters[active][$eq]': true,
                'sort': 'publishedAt:desc',
                // 'pagination[limit]': 1,
                'populate': '*', // falls Relationen oder Bilder enthalten sind
            },
            headers: {
                Authorization: `Bearer ${API_TOKEN_STRAPI}`,
            },
        });
        console.log(res.data.data[0]);

        return res.data.data[0];
    };

    useEffect(() => {
        fetchAllNews().then((content) => {
            setNewsData(content);
        });

    }, [])


    if (newsData == null) return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"news"} disableanimation={false} />

            <section className='sec_next' id='sec_next--newsdetails'>
                <div className='sec_next_cont' id="sec_next--newsdetails--cont" style={{ wordBreak: "break-word" }}>
                    <br /><br />
                    <div className='backbtn'><a href='/news'><FontAwesomeIcon icon={faChevronLeft} /> Zur Übersicht</a></div>
                    <br /><br />
                    <p>Die Daten zu der Meldung werden geladen...</p>
                </div>
            </section >

            <MainFooter />
        </div >
    )


    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"news"} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>News: {newsData.shorttitle}</title>
                <meta property="og:title" content={`News: ${newsData.shorttitle}`} />
                <meta property="og:description" content={`${newsData.subtitle}`} />
                <meta name="description" content={newsData.subtitle} />
            </Helmet>
            <section className='sec_next' id='sec_next--newsdetails'>
                <div className='sec_next_cont' id="sec_next--newsdetails--cont" style={{ wordBreak: "break-word" }}>

                    <motion.div variants={boxvar3} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <br /><br />

                        <div className='backbtn'><a href='/news'><FontAwesomeIcon icon={faChevronLeft} /> Zur Übersicht</a></div>

                        <h2>{newsData.title}</h2>

                        <h3>{newsData.newsdate} ● {newsData.author} ● {newsData.subtitle}</h3>
                        <br />
                        {(newsData.heroimage != null) ?
                            <img className='news_heroimg' src={`${URL_STRAPI}${newsData.heroimage?.url}`} alt={"Hero Image des News Artikels: " + newsData.heroimage?.alternativeText} />
                            : <div></div>}
                        <br /><br />
                        <div className='news_body'>
                            <MarkdownViewer
                                content={newsData.body.replace(/\n/g, '  \n')} />
                        </div>
                        <br /><br />
                        {newsData?.projects.length > 0 ?
                            <div>
                                <h3>Betroffene Projekte und Produkte:</h3>
                                <ul>
                                    {newsData?.projects.map((project) =>
                                        <li key={project.id}><a href={"/projects/" + project.projectid}>{project.name}</a></li>
                                    )}

                                </ul>

                            </div>
                            : <></>}

                    </motion.div>

                    <br /><br /><br /><br /><br /><br /><br />
                    <br /><br /><br /><br /><br /><br /><br />

                </div>
            </section >

            <MainFooter />
        </div >
    )
}